import axios from 'axios'
import interceptors from './dsp_request'

// allow use http client without Vue instance
const http = axios.create({
  // baseURL: 'http://local.adverts-api.com',// 后端本地
  // baseURL: 'http://dev.adverts-api.com',// aws 新加坡
  //baseURL: 'http://120.25.226.146:8089/', // 阿里云国内
  timeout: 10000
})

interceptors(http)


export default http



// WEBPACK FOOTER //
// ./src/http/request.js